import React from 'react';

function TextSlider({ text }) {
    return (
        <div className="wrapper mx-auto pt-4 py-md-4 mt-md-2">
            <marquee behavior="scroll" direction="left" scrollamount="6" scrolldelay="85" className="bg-haiti border-cherry rounded-2 py-2">
                <p className="text-white opacity-75 fs-18 m-0 mt-1">{text}</p>
            </marquee>
        </div>

    );
}

export default TextSlider;
